import { useFormikContext } from "formik";

import { LoansContainerProps } from "./Loans.types";

import { DEFAULT_LOAN_RATE } from "constants/calculator";

import { convertValueToLocaleForm } from "helpers/convertValueToLocale";

import Loans from "./Loans";

const LoansContainer = ({
  loans,
  activeTab,
  isDesktop,
  isRootAdmin,
}: LoansContainerProps) => {
  const { values, setFieldValue } = useFormikContext<any>();

  const handleLoanYearsChange = (value: any) => {
    const nextLoans = values.loans.map((loan: any) => {
      const nextLoan = loans.find((l: any) => l.devName === loan.devName);
      const period = nextLoan?.periods.find(
        (period: any) => period.from <= value * 12 && period.to >= value * 12
      );
      return {
        ...loan,
        startRate: convertValueToLocaleForm(
          period?.percent || DEFAULT_LOAN_RATE
        ),
        rate: convertValueToLocaleForm(nextLoan?.rate || DEFAULT_LOAN_RATE),
      };
    });
    setFieldValue("loans", nextLoans);
  };

  return (
    <Loans
      activeTab={activeTab}
      isDesktop={isDesktop}
      values={values}
      onLoanYearsChange={handleLoanYearsChange}
      isRootAdmin={isRootAdmin}
    />
  );
};

export default LoansContainer;
